import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {RoomPlannerProductWithTemplate} from 'components/customer/RoomPlanner/types';

/**
 * Configures opening heights for oven, microwave, and rangehood based on product type
 * Mutates the values object to set appropriate opening heights
 * @param {RoomPlannerProductWithTemplate} values - Product values
 * @param {TemplateVariable} variables - Template variables
 * @param {string} templateName - Template name
 * @return {void}
 */
export const configureOpeningHeights = (
    values: RoomPlannerProductWithTemplate,
    variables: TemplateVariable,
    templateName: string
): void => {
    const isOvenDrawer = templateName === 'BaseOvenDrawers.xml';
    const isOvenCabinet = templateName === 'BaseOven.xml';
    const hasMicrowave = [
        'BaseMicrowaveDrawers.xml',
        'UpperMicrowavePair.xml',
    ].includes(templateName);

    // Reset oven opening height if not an oven product
    if (!isOvenDrawer && !variables.isWallOvenProduct && !isOvenCabinet) {
        values.oven_opening_height = 0;
    }

    // Reset microwave opening height if not a microwave product
    if (!hasMicrowave && !variables.isWallOvenProduct) {
        values.microwave_opening_height = 0;
    }

    // Default the rangehood opening height unless one was saved
    if (
        variables.hasRangehoodVent &&
        !(Number(values.rangehood_opening_height) > 0)
    ) {
        values.rangehood_opening_height = 175;
    }

    // Reset microwave opening height for wall oven without microwave
    if (variables.isWallOvenProduct && (values.microwave_id ?? 0) <= 0) {
        values.microwave_opening_height = 0;
    }

    // Set drawer face flag
    variables.isDrawerFace = Boolean(
        values.drawer_face_heights || values.drawer_face_height
    );
};
